import { ProductStatsItem } from '../../helpers/report.types';

export const normalizeEngineersList = (
  value: ProductStatsItem['engineers'] | string | null | undefined
): string[] => {
  if (value === null || value === undefined) return [];
  if (Array.isArray(value)) {
    return value.map((s) => String(s).trim()).filter(Boolean);
  }
  if (typeof value === 'string' && value.trim() === '') return [];
  if (typeof value === 'string') {
    return value
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);
  }
  return [];
};

export const ENGINEERS_PREVIEW_LIMIT = 6;

export const truncateProductName = (value: string, max: number) =>
  value.length > max ? `${value.slice(0, max - 1)}…` : value;
